module.exports = __webpack_public_path__ + "static/media/Robots.a914adf3.txt";


//////////////////
// WEBPACK FOOTER
// ./public/Robots.txt
// module id = 1526
// module chunks = 1